import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Site, SitePostRequest } from '../interfaces/site';

@Injectable({
  providedIn: 'root'
})
export class SiteApiService {
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  postSites(sites: SitePostRequest) {
    return this.httpClient.post(this.baseUrl + 'sites', sites);
  }

  getSites() {
    return this.httpClient.get(this.baseUrl + 'sites');
  }

  getSite(id:string) {
    return this.httpClient.get(this.baseUrl + 'sites/' + id);
  }

  updateSite(site: Site) {
    return this.httpClient.put(this.baseUrl + 'sites/' + site.id, site);
  }

  setDailyQuotaLimit(siteId: any, limit: any) {
    if (limit != null)
      return this.httpClient.put(this.baseUrl + `sites/setDailyQuotaLimit/${siteId}/${limit}`, null);
    else
      return this.httpClient.put(this.baseUrl + `sites/setDailyQuotaLimit/${siteId}`, null);
  }

  setAutoIndexType(siteId: any, type: any) {
    
    return this.httpClient.put(this.baseUrl + `sites/setAutoIndexType/${siteId}`, type);
  }
}
